import { ItemGroupAlignment } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

import { getPendingChangeOutlinedHighlightStyles } from '../shared/styles';

export const getFormControlStyles = ({
  align,
  customStyles,
  width,
  error,
  columns,
  isFieldChanged,
}) => ({
  position: 'relative',
  flexDirection: align === ItemGroupAlignment.VERTICAL ? 'column' : 'row',
  alignItems: align === ItemGroupAlignment.VERTICAL ? 'start' : 'center',
  gap: '24px',
  justifyContent: 'flex-start',
  width,
  padding: '7px',
  color: ({ palette }) => (error ? `${palette.text.error} !important` : null),

  ...getConditionalObject(isFieldChanged, () => getPendingChangeOutlinedHighlightStyles(columns)),

  '& .radio-group, & .form-control-label': {
    gap: '16px',
  },

  '& .radio-group': {
    flexWrap: 'nowrap',
  },

  '.form-control-label': {
    zIndex: 1,
    gap: '8px',

    '& .Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26) !important',
    },

    '& .radio-button-label, & .radio-button-icon': {
      color: ({ palette }) => (error ? `${palette.text.error} !important` : null),
    },

    '& .radio-button-icon': {
      padding: 0,
    },
  },

  '& .label': {
    marginBottom: 0,
    color: ({ palette }) => palette.text.primary,
  },

  '& .helper-text': {
    padding: 0,
  },

  ...customStyles,
});

export const formControlLabelStyles = {
  margin: 0,
};
